import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const minus: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11-6.25v1.5q0 .316-.219.531A.72.72 0 0 1 10.25-4H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-4.75v-1.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-7h9.5q.31 0 .531.219A.74.74 0 0 1 11-6.25m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 7)"
    />
  ),
  svgProps: {
    height: "3",
    width: "11",
  }
};

export const minusCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.5-4.5v-1a.46.46 0 0 0-.156-.344A.46.46 0 0 0 9-6H3a.5.5 0 0 0-.36.156.47.47 0 0 0-.14.344v1q0 .206.14.36Q2.795-4 3-4h6q.201 0 .344-.14A.5.5 0 0 0 9.5-4.5m1.688-3.516Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
